import "./assets/css/index.scss";

import LikeCoinUI from "./components/LikeCoinUI";

export default LikeCoinUI;
export * from "./components";
